import React, { useEffect, useState } from 'react';
import styles from './TemplatesFormChange.module.scss';
import FormChange from './FormChange/FormChange';
import TemplatesPreview from '../TemplatesPreview/TemplatesPreview';
import { registrationTypes } from '../../../constants/registrationTypes';
import { parseCombinedData } from './FormChange/utils/parseCombinedData';
import { modeList } from '../../../constants/modeList';

const TemplatesFormChange = ({
  changeTemlateModem,
  selectedTemlates,
  templateModem,
  setSelectedTemlates,
  registrationTypeHouse,
}) => {
  const objFormOne = {
    title: '',
    message: '',
    phone: '',
    url: '',
    email: '',
    address: '',
  };

  const objFormTwo = {
    message: '',
    phone: '',
    url: '',
    email: '',
    address: '',
  };

  const isClosedType = registrationTypeHouse.id === registrationTypes.closed.id;
  const isPersonalAccountType =
    registrationTypeHouse.id === registrationTypes.personalAccounts.id;
  const messageOne = selectedTemlates?.message;
  const messageTwo = selectedTemlates?.message2;

  const [stateForm, setStateForm] = useState(objFormOne);
  const [blocks, setBlocks] = useState({
    block1: { ...objFormOne },
    block2: { ...objFormTwo },
  });
  const [activeBlock, setActiveBlock] = useState('block1');

  useEffect(() => {
    if (templateModem === modeList.CHENGE_MODE) {
      if (isClosedType) {
        const { title, message, phone, url, email, address } =
          parseCombinedData(messageOne);
        // Логика для одного блока
        setStateForm({
          title,
          message,
          phone,
          url,
          email,
          address,
        });
      } else if (isPersonalAccountType) {
        const messageParse = parseCombinedData(messageOne);
        const message2Parse = parseCombinedData(messageTwo);

        // Логика для двух блоков
        setBlocks((prev) => ({
          ...prev,
          block1: messageParse,
          block2: message2Parse,
        }));
      }
    }
  }, [
    templateModem,
    registrationTypeHouse,
    isClosedType,
    isPersonalAccountType,
    messageOne,
    messageTwo,
  ]);

  const changeForm = (e) => {
    const { name, value } = e.target;

    if (isClosedType) {
      // Изменение для одного блока
      setStateForm((prev) => ({
        ...prev,
        [name]: value,
      }));
    } else if (isPersonalAccountType) {
      // Изменение для активного блока
      setBlocks((prev) => ({
        ...prev,
        [activeBlock]: {
          ...prev[activeBlock],
          [name]: value,
        },
      }));
    }
  };

  const switchBlock = (blockName) => {
    setActiveBlock(blockName);
  };

  return (
    <>
      <FormChange
        switchBlock={switchBlock}
        registrationTypeHouse={registrationTypeHouse}
        setSelectedTemlates={setSelectedTemlates}
        templateModem={templateModem}
        changeForm={changeForm}
        selectedTemlates={selectedTemlates}
        stateForm={stateForm}
        changeTemlateModem={changeTemlateModem}
        activeBlock={activeBlock}
        blocks={blocks}
        setBlocks={setBlocks}
      />
      <div className={styles.conteiner}>
        <div className={styles.header}>
          <h3 className={styles.title}>Предпросмотр</h3>
        </div>
        <div className={styles.preview}>
          <TemplatesPreview
            registrationTypeHouse={registrationTypeHouse}
            stateForm={stateForm}
            blocks={blocks}
          />
        </div>
      </div>
    </>
  );
};

export default TemplatesFormChange;
